document.addEventListener("DOMContentLoaded", function() {
    var mobileTrigger = document.querySelector(".btn-mobile-menu-drawer-trigger");
    var header = document.querySelector("header.cb-header");

    // Fix typo: .remote() should be .remove()
    mobileTrigger.addEventListener("click", function() {
        document.querySelector("header-drawer details summary span").click();

        if (document.querySelector("header-drawer .menu-drawer-container").hasAttribute('open')) {
            header.classList.add("cb_black_header");
        } else {
            header.classList.remove("cb_black_header");
        }
    });

    // Safari-specific fix: Add touchstart event for better mobile compatibility
    mobileTrigger.addEventListener("touchstart", function(event) {
        event.preventDefault();
        document.querySelector("header-drawer details summary span").click();
        
        setTimeout(() => {
            if (document.querySelector("header-drawer .menu-drawer-container").hasAttribute('open')) {
                header.classList.add("cb_black_header");
            } else {
                header.classList.remove("cb_black_header");
            }
        }, 50);
    });

    document.querySelectorAll(".custom-drawer-menu-item-links-heading").forEach(heading => {
        heading.addEventListener("click", function() {
            console.log(heading.closest("details"));

            if (heading.closest("details").hasAttribute('open')) {
                heading.closest("details").removeAttribute('open');
            }
        });
    });

    document.querySelectorAll(".cb-btn-video-play").forEach(btn => {
        btn.addEventListener("click" , function() {
            if(this.getAttribute("data-state") == "play") {
                this.closest(".cb-video-container").querySelector("video").play();
                this.setAttribute("data-state", "stop");
            }else {
                this.closest(".cb-video-container").querySelector("video").pause();
                this.setAttribute("data-state", "play");
            }
        });
    });

    // Read More button functionality
    const readMoreButton = document.querySelector('.read-more-button');
    if (readMoreButton) {
        readMoreButton.addEventListener('click', async function() {
            const currentPage = parseInt(this.dataset.currentPage);
            const totalPages = parseInt(this.dataset.totalPages);
            
            if (currentPage >= totalPages) {
                this.disabled = true;
                return;
            }
          
            if (this.hasAttribute('data-disabled')) {
              return;
            }

            // Show loading state
            this.textContent = 'Loading...';
            this.setAttribute('data-disabled', true);

            try {
                // Get the current URL and add the page parameter
                const url = new URL(window.location.href);
                url.searchParams.set('page', currentPage + 1);

                // Fetch the next page
                const response = await fetch(url);
                const html = await response.text();

                // Create a temporary container to parse the HTML
                const tempContainer = document.createElement('div');
                tempContainer.innerHTML = html;

                // Get the new products
                const newProducts = tempContainer.querySelector('#product-grid').innerHTML;

                // Append new products to the existing grid
                document.querySelector('#product-grid').insertAdjacentHTML('beforeend', newProducts);

                // Update the current page
                this.dataset.currentPage = currentPage + 1;

                // Reset button state
                this.textContent = 'Read More';
                this.setAttribute('data-disabled', false);

                // Disable button if we've reached the last page
                if (currentPage + 1 >= totalPages) {
                    this.disabled = true;
                }
            } catch (error) {
                console.error('Error loading more products:', error);
                this.textContent = 'Read More';
            }
        });
    }

    // View More button functionality for blog
    const viewMoreButton = document.querySelector('.view-more-button');
    if (viewMoreButton) {
        viewMoreButton.addEventListener('click', async function() {
            const currentPage = parseInt(this.dataset.currentPage);
            const totalPages = parseInt(this.dataset.totalPages);
            
            if (currentPage >= totalPages) {
                this.disabled = true;
                return;
            }

            if (this.hasAttribute("data-disabled")) {
              return;
            }

            this.setAttribute('data-disabled', true);

            // Show loading state
            this.textContent = 'Loading...';

            try {
                // Get the current URL and add the page parameter
                const url = new URL(window.location.href);
                url.searchParams.set('page', currentPage + 1);

                // Fetch the next page
                const response = await fetch(url);
                const html = await response.text();

                // Create a temporary container to parse the HTML
                const tempContainer = document.createElement('div');
                tempContainer.innerHTML = html;

                // Get the new articles
                const newArticles = tempContainer.querySelector('#blog-articles').innerHTML;

                // Append new articles to the existing grid
                document.querySelector('#blog-articles').insertAdjacentHTML('beforeend', newArticles);

                // Update the current page
                this.dataset.currentPage = currentPage + 1;

                // Reset button state
                this.textContent = 'View More';

                this.setAttribute('data-disabled', false);

                // Disable button if we've reached the last page
                if (currentPage + 1 >= totalPages) {
                    this.disabled = true;
                }
            } catch (error) {
                console.error('Error loading more articles:', error);
                this.textContent = 'View More';
                this.disabled = false;
            }
        });
    }
});